export const en = {
  nav: {
    home: 'Home',
    services: 'Our Services',
    about: 'About Us',
    contact: 'Contact Us',
    language: 'العربية'
  },
  hero: {
    title: 'The Future of Agriculture in Qatar',
    subtitle: 'Smart and sustainable agricultural solutions supporting Qatar Vision 2030',
    cta1: 'Discover Our Services',
    cta2: 'Contact Us'
  },
  services: {
    label: 'Our Services',
    title: 'Comprehensive Agricultural Solutions',
    subtitle: 'We provide the latest technologies to achieve sustainability and high productivity',
    readMore: 'Read More',
    service1: {
      title: 'Smart Agriculture',
      description: 'AI-powered automated monitoring systems to optimize productivity and reduce resource consumption'
    },
    service2: {
      title: 'Vertical & Soilless Farming',
      description: 'Advanced hydroponic and semi-hydroponic systems for year-round high-quality crop production'
    },
    service3: {
      title: 'Soil & Seasonal Farming',
      description: 'Improving soil quality and exporting national products with the highest global quality standards'
    },
    service4: {
      title: 'Consulting & Design',
      description: 'Building turnkey farms for individuals and companies with customized solutions for your needs'
    }
  },
  about: {
    label: 'About Us',
    title: 'Leading a Technological Revolution in Qatar\'s Agriculture',
    description: 'At EVE Smart Agricultural Services, we are leading a technological revolution in Qatar\'s agricultural sector. We believe the future lies in merging innovation with sustainability. We specialize in smart farming solutions, hydroponics, and vertical farming systems that guarantee maximum productivity with minimal resource consumption.',
    description2: 'Our mission is to bolster national food security and empower investors and farmers through next-generation technology, transforming environmental challenges into sustainable growth opportunities.',
    cta: 'Learn Our Story',
    stat: 'Smart Agricultural Projects',
    badge: 'Trusted Partner',
    since: 'Since 2020'
  },
  values: {
    title: 'Our Core Values',
    value1: {
      title: 'Innovation',
      description: 'We use the latest technologies and innovative solutions to develop the agricultural sector'
    },
    value2: {
      title: 'Sustainability',
      description: 'We commit to sustainable farming practices that preserve the environment for future generations'
    },
    value3: {
      title: 'Quality',
      description: 'We guarantee the highest quality standards in all our agricultural services and products'
    }
  },
  cta: {
    question1: 'Are you ready',
    question2: 'to transform your farm',
    question3: 'into a smart project?',
    button: 'Start Now'
  },
  footer: {
    newsletter: {
      title: 'Stay Updated',
      subtitle: 'Subscribe to our newsletter for the latest agricultural innovations',
      placeholder: 'Your email address',
      button: 'Subscribe'
    },
    quickLinks: {
      title: 'Quick Links',
      home: 'Home',
      services: 'Our Services',
      projects: 'Projects',
      contact: 'Contact Us'
    },
    contact: {
      title: 'Contact Us',
      email: 'evevsmart@gmail.com',
      locationTitle: 'Our Location',
      location1: 'Doha, Qatar',
      location2: 'Zone 80, Street 9999'
    },
    copyright: '© 2026 EVE Smart. All Rights Reserved',
    privacy: 'Privacy Policy',
    terms: 'Terms & Conditions',
    poweredBy: 'Powered by Readdy'
  },
  privacy: {
    title: 'Privacy Policy',
    description: 'Privacy Policy for EVE Smart Agricultural Services',
    section1: {
      title: 'Introduction',
      content: 'At EVE Smart Agricultural Services, we are committed to protecting your privacy and the security of your personal information. This Privacy Policy explains how we collect, use, protect, and share information obtained through our website and services.'
    },
    section2: {
      title: 'Information We Collect',
      content: 'We collect various types of information to provide and improve our services to you:',
      item1: 'Personal Information: Name, email, phone number, address',
      item2: 'Company Information: Company name, business type, location',
      item3: 'Technical Information: IP address, browser type, operating system',
      item4: 'Usage Information: How you interact with our website and services'
    },
    section3: {
      title: 'How We Use Information',
      content: 'We use the information we collect for the following purposes:',
      item1: 'Provide and improve our smart agricultural services',
      item2: 'Communicate with you regarding your inquiries and requests',
      item3: 'Send updates about our new services and products',
      item4: 'Analyze and improve our website performance'
    },
    section4: {
      title: 'Information Protection',
      content: 'We take strict security measures to protect your personal information from unauthorized access, alteration, disclosure, or destruction. We use encryption technologies and secure protocols to ensure the integrity of your data.'
    },
    section5: {
      title: 'Information Sharing',
      content: 'We do not sell, rent, or share your personal information with third parties except in the following cases: when necessary to provide our services, when we obtain your explicit consent, or when required by law.'
    },
    section6: {
      title: 'Cookies',
      content: 'We use cookies and similar technologies to improve your experience on our website. You can control the use of cookies through your browser settings.'
    },
    section7: {
      title: 'Your Rights',
      content: 'You have the right to access, correct, or delete your personal information. You can also object to the processing of your data or request restriction of its use. To exercise any of these rights, please contact us.'
    },
    contact: {
      title: 'Contact Us',
      content: 'If you have any questions or inquiries about this Privacy Policy, please contact us:',
      email: 'Email',
      phone: 'Phone'
    },
    lastUpdated: 'Last Updated: January 2025'
  },
  terms: {
    title: 'Terms & Conditions',
    lastUpdated: 'Last Updated',
    intro: 'Welcome to EVE Smart Agricultural Services. By using our website and services, you agree to comply with the following terms and conditions. Please read them carefully.',
    acceptance: {
      title: '1. Acceptance of Terms',
      content: 'By using our website or services, you agree to be bound by these terms and conditions and all applicable laws and regulations. If you do not agree with any of these terms, you are prohibited from using our site or services.'
    },
    services: {
      title: '2. Services Provided',
      content: 'EVE Smart provides specialized agricultural services including smart farming, hydroponics, and vertical farming. We reserve the right to modify or discontinue any service at any time without prior notice.'
    },
    userResponsibilities: {
      title: '3. User Responsibilities',
      content: 'Users agree to use our services in a legal and responsible manner. Using the site for any illegal or harmful purposes is prohibited. Users must provide accurate and truthful information when contacting us or requesting our services.'
    },
    intellectualProperty: {
      title: '4. Intellectual Property',
      content: 'All content on this website, including text, images, logos, and designs, is owned by EVE Smart and protected under copyright and intellectual property laws. Copying, distributing, or using any content without prior written permission is prohibited.'
    },
    liability: {
      title: '5. Disclaimer',
      content: 'We strive to provide accurate and reliable information, but we do not guarantee the accuracy or completeness of the content on our site. EVE Smart is not liable for any direct or indirect damages resulting from the use of our website or services.'
    },
    modifications: {
      title: '6. Modifications to Terms',
      content: 'We reserve the right to modify these terms and conditions at any time. Any changes will be posted on this page with an updated "Last Updated" date. Your continued use of the site after modifications means you accept the updated terms.'
    },
    governingLaw: {
      title: '7. Governing Law',
      content: 'These terms and conditions are governed by the laws of the State of Qatar. Any disputes arising from the use of our website or services will be resolved in accordance with Qatari law.'
    },
    contact: {
      title: '8. Contact Us',
      content: 'If you have any questions or inquiries about these terms and conditions, please contact us:'
    }
  }
};

export default en;